<template>
  <div>首页
    <button @click="showa">显示A组件{{username}}</button>
    <button @click="showb">显示B组件{{getUsernameNS}}</button>
    <button @click="editUN(123)">修改username</button>
    <button @click="updateNN(123)">修改nickname</button>
    <button @click="openUpload">上传</button>
    <button @click="showToast">显示弹窗</button>
    <button @click="requestData">请求测试</button>
    <button class="changeColor" @click="changeThemeColor">改变主题色</button>
    <keep-alive>
      <component v-bind:is="comname"></component>
    </keep-alive>
  </div>

</template>

<script>
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  import replacer from 'webpack-theme-color-replacer/client'

  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

  export default {
    name: "",
    data() {
      return {
        comname: null
      }
    },
    computed: {
      count: function () {
        return 123;
      },
      ...mapState(['username']),
      ...mapGetters(['getUsernameNS'])
    },
    methods: {
      showa: function () {
        this.comname = "first";
      },
      showb: function () {
        this.comname = "second";
      },
      openUpload() {
        this.$modal.show("upload");
      },
      showToast() {
        this.$notify({
          group: 'global',
          title: 'test',
          text: 'test text~~~',
        });
      },
      async requestData() {
        let data = await axios.post(apiConfig.REQUEST_URL + "/shall/front_userInfo");
        console.log("请求的数据：")
        console.log(data.data)
      },
      getColor: function () {//十六进制颜色随机
        var r = Math.floor(Math.random() * 256);
        var g = Math.floor(Math.random() * 256);
        var b = Math.floor(Math.random() * 256);
        var color = '#' + r.toString(16) + g.toString(16) + b.toString(16);
        return color;
      },
      changeThemeColor() {
        let options = {
          newColors: [this.getColor(), this.getColor()], // new colors array, one-to-one corresponde with `matchColors`
          // appendToEl: 'head', //optional. The element selector for appending child with `<style>`, default is 'body'. Using `appendToEl: 'body'` can make the css priority higher than any css in <head>
          // changeUrl(cssUrl) {
          //   return `/${cssUrl}`; // while router is not `hash` mode, it needs absolute path
          // },
        }
        replacer.changer.changeColor(options, Promise).then(() => {
          console.log('Theme colors changed!')
        })
      },
      ...mapMutations({editUN: 'updateUsername'}),
      ...mapActions({updateNN: "updateNickName"})
    },
    components: {
      first: {template: "<p>first<input type='text'/></p>"},
      second: {template: "<p>second<input type='text'/></p>"}
    },
    mounted() {
      let self = this;

    }

  }
</script>

<style scoped>
  input {
    border: 1px solid #ccc;
  }

  .changeColor {
    background-color: #ff00ff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/test.vue